import { stripNumberSeparators } from '@paytms/shared';

/**
 * 전화번호 표시 포맷 — 저장값은 숫자만이고, 화면에 보일 때 하이픈을 넣는다(2026-09-15).
 *
 * | 자리 | 조건            | 표시           | 예                        |
 * |------|-----------------|----------------|---------------------------|
 * | 8    | 15xx·16xx·18xx  | 0000-0000      | 1588-1234                 |
 * | 9    | 02              | 02-000-0000    | 02-123-4567               |
 * | 10   | 02              | 02-0000-0000   | 02-1234-5678              |
 * | 10   | 그 외           | 000-000-0000   | 031-123-4567 · 010-123-4567 |
 * | 11   | —               | 000-0000-0000  | 010-1234-5678 · 050-1234-5678 |
 * | 12   | —               | 0000-0000-0000 | 0505-1234-5678 (안전번호) |
 *
 * 표 밖 길이(7자리 이하, 13자리 이상, 8자리인데 대표번호가 아닌 것)와 구분 기호 외의 문자
 * (`+82…`, 글자)가 섞인 값은 **원문 그대로** 돌려준다 —
 * 잘못 저장된 값을 화면이 그럴듯하게 꾸며 주지 않아야 눈에 띈다. 빈 값(null·undefined·'')은
 * 빈 문자열이고, 그리드의 `'-'` 규칙은 호출부가 정한다(`formatBizNo`와 같은 계약).
 */
export function formatPhone(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  // 서버·applyFormat과 같은 규칙 — 구분 기호만 걷어낸다. `+82`가 붙은 값은 자릿수가 맞아도 포맷하지 않는다
  const digits = stripNumberSeparators(value);
  if (!/^\d+$/.test(digits)) {
    return value;
  }
  switch (digits.length) {
    case 8:
      return /^1[568]/.test(digits) ? `${digits.slice(0, 4)}-${digits.slice(4)}` : value;
    case 9:
      return digits.startsWith('02')
        ? `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`
        : value;
    case 10:
      return digits.startsWith('02')
        ? `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6)}`
        : `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    case 11:
      return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
    case 12:
      return `${digits.slice(0, 4)}-${digits.slice(4, 8)}-${digits.slice(8)}`;
    default:
      return value;
  }
}
